import prepare from '@drivesally/sally-fw/lib/attribute/prepare.attribute';

export default (attributes) =>
  prepare(attributes, {
    field: 'api',
    required: ['hold_type', 'reason', 'vehicle'],
  });
